import axios from "axios";
import store from "@/store";

// Folga para o token nao vencer entre a checagem e a resposta da API.
const EXPIRY_SKEW_MS = 30 * 1000;

function tokenPayload(token) {
  try {
    const part = String(token).split(".")[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

// Token que ainda passa no guard da API: JWT legivel e dentro da validade.
// Sem `exp` nao da para afirmar que venceu, entao vale ate a API recusar.
export function isTokenValid(token) {
  const payload = tokenPayload(token);
  if (!payload) return false;
  if (typeof payload.exp !== "number") return true;
  return payload.exp * 1000 - EXPIRY_SKEW_MS > Date.now();
}

// Renovacao em andamento: chamadas recusadas ao mesmo tempo esperam a mesma,
// em vez de cada uma gastar o refresh (que muda a cada renovacao).
let pendingRefresh = null;

// Troca o refresh (7d) por um token de acesso novo (1h) e um refresh novo.
// Devolve false sem refresh ou quando a API recusa; quem chamou decide sair.
// Vai direto pelo axios, sem o BaseAPIClient, para um 401 aqui nao tentar
// renovar de novo.
export function refreshSession() {
  if (pendingRefresh) return pendingRefresh;

  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken || refreshToken === "null") return Promise.resolve(false);

  pendingRefresh = axios
    .post(`${process.env.VUE_APP_PITCH_API}/refresh-token`, { refreshToken })
    .then(({ data }) => {
      if (!data?.auth) return false;
      store.dispatch("setToken", data.auth);
      store.dispatch("setRefreshToken", data.refreshToken);
      return true;
    })
    .catch(() => false)
    .finally(() => {
      pendingRefresh = null;
    });

  return pendingRefresh;
}
